import { combineReducers } from "redux";
import designReducers from "./reducer";

const rootReducer = combineReducers({
    data: designReducers
})

export default rootReducer;